import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import routeOptimalizationActions from '../../../redux/modules/routeOptimalization/routeOptimalizationActions';
import PropTypes from 'prop-types';
import { locale } from '../../../common/localization/localizationService';
import AddCustomerModal from '../AddCustomerModal';
import RouteGrid from '../RouteGrid';
import './importedRouteGrid.scss';
import { groupByReduce } from '../../../services/listService';
import { WarningBanner } from '../../routeAdminLayer/WarningBanner';
import Select from 'react-select';

class ImportedRouteGrid extends Component {
  constructor(props) {
    super(props);

    this.showAddCustomerModal = this.showAddCustomerModal.bind(this);
    this.hideAddCustomerModal = this.hideAddCustomerModal.bind(this);
    this.handleRouteAdded = this.handleRouteAdded.bind(this);
    this.handleRouteRemoved = this.handleRouteRemoved.bind(this);
  }

  allButtonFilter = {
    label: locale.routeOptimalizationWizard.filterOrderTypes._all,
    value: 0,
  };

  filterButtons = [
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._extraEmptying,
      value: 1,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._collectUnit,
      value: 2,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes
          ._additionalServicePickup,
      value: 15,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._emptying,
      value: 3,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._markSteel,
      value: 4,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._replaceUnit,
      value: 5,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._replaceChip,
      value: 6,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._urgentEmptying,
      value: 7,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes._routeExtraEmptying,
      value: 8,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._createLabel,
      value: 9,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._regularEmptying,
      value: 10,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._placeUnit,
      value: 11,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._serviceOrder,
      value: 12,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes._serviceAgreement,
      value: 13,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._salesOrder,
      value: 14,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._routePlanning,
      value: 16,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes._slamRegularEmptying,
      value: 101,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes._slamOffRouteEmptying,
      value: 102,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes
          ._slamEmergencyEmptying,
      value: 103,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._slamFlushing,
      value: 104,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes._slamImmediateHelp,
      value: 105,
    },
    {
      label:
        locale.routeOptimalizationWizard.filterOrderTypes
          ._slamFixedWeekEmptying,
      value: 106,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._extraSweeping,
      value: 211,
    },
    {
      label: locale.routeOptimalizationWizard.filterOrderTypes._extraInspection,
      value: 212,
    },
  ];

  state = {
    addCustomerModalVisible: false,
    selectedFilters:
      this.getTypes(this.props.importedRoutes).length <= 5
        ? [this.allButtonFilter]
        : [],
  };

  static getNewRowDefaultDate(filteredRoutes) {
    if (!filteredRoutes || filteredRoutes.length === 0) {
      return null;
    }

    const date = filteredRoutes[0].date;
    if (filteredRoutes.every((r) => r.date.getTime() === date.getTime())) {
      return date;
    }

    return null;
  }

  showAddCustomerModal() {
    this.setState({ addCustomerModalVisible: true });
  }

  hideAddCustomerModal() {
    this.setState({ addCustomerModalVisible: false });
  }

  handleRouteAdded(customer) {
    const { routeOptimalizationActions, agreements } = this.props;
    const { agreement: agreementOption, ...rest } = customer;

    const relatedAgreement = agreements.find(
      (a) => a.agreementId === agreementOption.value
    );

    const route = {
      customerName: agreementOption.label,
      gln: agreementOption.value,
      latitude: relatedAgreement.degLat,
      longitude: relatedAgreement.degLon,
      ...rest,
    };

    routeOptimalizationActions.addImportedRoute(route);
    this.hideAddCustomerModal();
  }

  handleRouteRemoved(route) {
    const { routeOptimalizationActions } = this.props;
    routeOptimalizationActions.removeImportedRoute(
      route.gln,
      route.orderNumber
    );
  }

  getDuplicateRoutes() {
    const { filteredRoutes } = this.props;
    if (!filteredRoutes || filteredRoutes.length === 0) {
      return null;
    }

    const groupedRoutes = groupByReduce(
      filteredRoutes,
      (route) => `${route.gln}-${route.serial}`
    );

    const duplicates = [];
    for (let [key, routes] of Object.entries(groupedRoutes)) {
      if (routes.length > 1) {
        duplicates.push(key);
      }
    }

    if (duplicates.length === 0) {
      return null;
    }

    const glns = new Set();
    const serials = new Set();

    duplicates.forEach((key) => {
      const [gln, serial] = key.split('-');
      glns.add(gln);
      serials.add(serial);
    });

    return {
      glns: Array.from(glns),
      serials: Array.from(serials),
    };
  }

  getDuplicatesText(duplicates) {
    if (!duplicates) {
      return null;
    }
    return `${locale.routeOptimalizationWizard._duplicateRoutesWarning}: ${
      locale.routeOptimalizationWizard.routesGrid._gln
    }: ${duplicates['glns'].join(', ')}, ${
      locale.routeOptimalizationWizard.routesGrid._serial
    }: ${duplicates['serials'].join(', ')}`;
  }

  selectFilteredOrderType = (types) => {
    const filteredOrders = this.getFilterRoutes(
      this.props.importedRoutes,
      types
    );
    this.props.routeOptimalizationActions.setFilteredOrders(filteredOrders);

    this.setState({ ...this.state, selectedFilters: types });
  };

  toggleFilterButtons(type) {
    this.setState((prevState) => {
      let selected = [...prevState.selectedFilters];
      if (type.value === 0) {
        selected = [this.allButtonFilter];
      } else {
        const index = selected.map((e) => e.value).indexOf(type.value);
        const allIndex = selected.map((e) => e.value).indexOf(0);
        if (allIndex !== -1) {
          selected.splice(allIndex, 1);
        }
        if (index > -1) {
          selected.splice(index, 1);
        } else {
          selected.push(type);
        }
        if (selected.length === 0) {
          selected = [this.allButtonFilter];
        }
      }
      this.props.routeOptimalizationActions.setFilteredOrders(
        this.getFilterRoutes(this.props.importedRoutes, selected)
      );
      return { selectedFilters: selected };
    });
  }

  getTypes(routes) {
    const types = [];
    routes.forEach((route) => {
      if (!types.includes(route.orderType)) {
        types.push(route.orderType);
      }
    });
    return types;
  }

  getFilterTypes(orderTypes, filterTypes) {
    return filterTypes.filter((filter) => orderTypes.includes(filter.value));
  }

  getFilterRoutes(routes, selectedFilters) {
    if (
      selectedFilters.length === 0 ||
      selectedFilters.some((e) => e.value === 0)
    ) {
      return routes;
    } else {
      const filteredRoutes = routes.filter((route) => {
        return selectedFilters.some((e) => route.orderType === e.value);
      });
      return filteredRoutes;
    }
  }

  render() {
    const { importedRoutes, filteredRoutes } = this.props;
    const { addCustomerModalVisible } = this.state;

    const newRowDefaultDate =
      ImportedRouteGrid.getNewRowDefaultDate(filteredRoutes);
    const currentAgreements = filteredRoutes.map((route) => route.gln);

    const duplicateGlns = this.getDuplicateRoutes();

    const routes = importedRoutes.map((route) => {
      if (!route.orderNumber && route.serial) {
        route.orderNumber = route.serial;
      }
      return route;
    });

    const types = this.getTypes(routes);

    const filterOptions = this.getFilterTypes(types, this.filterButtons);

    // const filteredRoutes = this.getFilterRoutes(routes);

    return (
      <div className="imported-route-grid">
        <div className="grid-headline-row">
          <div className="filter-field-wrapper">
            {filterOptions.length > 5 && (
              <Select
                options={filterOptions}
                value={this.state.selectedFilters}
                onChange={this.selectFilteredOrderType}
                isMulti
                className="input-field react-select route-opt-wizard-filter"
                closeMenuOnSelect={false}
                classNamePrefix="route-opt-wizard-filter"
                placeholder={
                  locale.routeOptimalizationWizard.filterOrderTypes
                    ._selectOrderType
                }
              />
            )}

            {filterOptions.length <= 5 && (
              <>
                <button
                  className={`btn btn-outline-dark back-nav-button route-wizard-filter-button ${
                    this.state.selectedFilters.some(
                      (e) => e.value === this.allButtonFilter.value
                    )
                      ? 'selected'
                      : ''
                  }`}
                  onClick={() => this.toggleFilterButtons(this.allButtonFilter)}
                >
                  <span>
                    {locale.routeOptimalizationWizard.filterOrderTypes._all}
                  </span>
                </button>
                {filterOptions.map((filterButton) => (
                  <button
                    className={`btn btn-outline-dark back-nav-button route-wizard-filter-button ${
                      this.state.selectedFilters.some(
                        (e) => e.value === filterButton.value
                      )
                        ? 'selected'
                        : ''
                    }`}
                    onClick={() => this.toggleFilterButtons(filterButton)}
                  >
                    <span>{filterButton.label}</span>
                  </button>
                ))}
              </>
            )}
          </div>
          <WarningBanner
            hidden={!duplicateGlns}
            text={this.getDuplicatesText(duplicateGlns)}
          />
        </div>
        <RouteGrid
          routes={filteredRoutes}
          removeItem={this.handleRouteRemoved}
        />
        {addCustomerModalVisible && (
          <AddCustomerModal
            onClose={this.hideAddCustomerModal}
            currentAgreements={currentAgreements}
            defaultDate={newRowDefaultDate}
            onSubmit={this.handleRouteAdded}
          />
        )}
      </div>
    );
  }
}

ImportedRouteGrid.propTypes = {
  importedRoutes: PropTypes.array.isRequired,
  filteredRoutes: PropTypes.array.isRequired,
  agreements: PropTypes.array.isRequired,
  onRouteAdded: PropTypes.func,
  routeOptimalizationActions: PropTypes.object.isRequired,
};

ImportedRouteGrid.defaultProps = {
  importedRoutes: [],
  filteredRoutes: [],
  onRouteAdded: () => {},
  routeOptimalizationActions: {},
};

function mapStateToProps(state) {
  return {
    importedRoutes: state.routeOptimalization.importedRoutes,
    filteredRoutes: state.routeOptimalization.filteredRoutes,
    agreements: state.agreement.agreements,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    routeOptimalizationActions: bindActionCreators(
      routeOptimalizationActions,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportedRouteGrid);
